import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {TFeatures} from '../../../user-access/models/user-access-features/user-access-features';

export interface ISettingsSection {
  aufFeatures: TFeatures[];
  header: string;
  icon: IconsEnum;
}
